'use strict';

var $ = require('jquery');

function init() {

	$('.dynamicForm[data-url]').each(function() {
		var $this = $(this);
		var url = $this.attr('data-url') + '?siteID=american-liberty-web';

		function modifyActionOnForm() {
			$this.find('#formWrapper form').attr('action', url);
		}

		$(document).on('jsfAjaxEvent', function (event) {
			if (event.detail.fireType === "always") {
				modifyActionOnForm();
			}
		});

		$.ajax({
			url: url,
			error: function(data) {
				console.error(data);
			},
			success: function(data) {
				$('#formWrapper', data).appendTo($this);
				modifyActionOnForm();
			},
			async: false
		});
	});
}

module.exports = {
	init: init
};
